import type { TFunction } from 'i18next';
import { toNumber, toString } from 'lodash-es';
import { dashString } from '../../utils/dashString.util';
import type { LogicalDeviceSummaryHardware } from '../logical-device-summary-card/logicalDeviceSummaryCard.model';
import styles from './logicalDeviceHardwareStatusCharts.module.scss';

export function getInverseValue(value: number): number {
  return 100 - value;
}

export function getPercentageLabel({
  addFreeSuffix,
  inverse,
  value,
  t,
}: {
  readonly value?: number;
  readonly addFreeSuffix?: boolean;
  readonly inverse?: boolean;
  readonly t: TFunction;
}): string {
  return `${inverse ? getInverseValue(toNumber(value)) : toNumber(value)}%${addFreeSuffix ? ` ${t('free')}` : ''}`;
}

export function getDisplayedPercentageValue({
  value,
  displayEmptyAsDash,
  addFreeSuffix,
  inverse,
  t,
}: {
  readonly value?: number;
  readonly displayEmptyAsDash?: boolean;
  readonly addFreeSuffix?: boolean;
  readonly inverse?: boolean;
  readonly t: TFunction;
}): string {
  if (displayEmptyAsDash) {
    return value === undefined ? dashString() : getPercentageLabel({ addFreeSuffix, inverse, value, t });
  } else {
    return getPercentageLabel({ addFreeSuffix, inverse, value, t });
  }
}

export function checkShouldDisplayChart(
  value?: Partial<LogicalDeviceSummaryHardware>,
  key?: keyof Partial<LogicalDeviceSummaryHardware>,
  displayEmptyAsDash?: boolean,
): boolean {
  return !!value?.[toString(key) as keyof typeof value] || !!displayEmptyAsDash;
}

export function getEmptyClassName(
  value?: Partial<LogicalDeviceSummaryHardware>,
  key?: keyof Partial<LogicalDeviceSummaryHardware>,
): string {
  return value?.[toString(key) as keyof typeof value] ? '' : styles.emptyChartContainer;
}
